import React, { useState } from "react";
import { Card, Row, Col } from "react-bootstrap";
import ModalComponent from "../../../Appoinment/component/ModalComponent";
import { useLocation } from "react-router-dom";
import { BUCKET_URL } from "../../../../../Service/api/ApiUrls";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import AddProgressNotes from "../AddForms/AddProgressNotes";
import Pagination from "../../../../../Component/DigitalMarketing/Pagination";

// pdfjs worker
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

// helpers
const buildFileUrl = (filepath = "", fileName = "") => {
  if (!fileName) return null;
  const cleanPath = filepath ? filepath.replace(/^\/+|\/+$/g, "") + "/" : "";
  return `${BUCKET_URL}/${cleanPath}${fileName}`;
};
const isImageFile = (filename = "") =>
  /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filename);
const isPdfFile = (filename = "") => /\.pdf$/i.test(filename);

const ProgressNotes = ({ ProgressNoteData, pagination, setPagination, refetch }) => {
  const notesData = ProgressNoteData?.data || [];
  const totalPages = ProgressNoteData?.total_pages || 1;

  const [progressNotesModal, setProgressNotesModal] = useState(false);
  const location = useLocation();
  const { consultantId } = location.state || {};

  const handleAdd = () => {
    setProgressNotesModal(true);
  };

  const renderThumbnail = (note, index) => {
    const fileUrl = buildFileUrl(note.filepath, note.fileName);
    return (
      <Col key={index} xs="auto" className="text-center">
        {fileUrl ? (
          <a
            href={fileUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <div
              style={{
                height: "130px",
                width: "100px",
                overflow: "hidden",
                border: "1px solid #ddd",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "6px",
              }}
            >
              {isImageFile(note.fileName) ? (
                <img
                  src={fileUrl}
                  alt={note.fileName}
                  style={{ maxHeight: "100%", maxWidth: "100%" }}
                />
              ) : isPdfFile(note.fileName) ? (
                <Document file={fileUrl}>
                  <Page pageNumber={1} width={100} />
                </Document>
              ) : (
                <span className="text-muted f-12">Unsupported</span>
              )}
            </div>
          </a>
        ) : null}
        <div style={{ fontSize: "12px", color: "#555" }}>{note.notes || "Progress Note"}</div>
      </Col>
    );
  };

  return (
    <div>
      {consultantId && (
        <div className="d-flex justify-content-end mb-3">
          <button
            className="btn btn-violet d-flex align-items-center"
            onClick={handleAdd}
          >
            <span className="material-symbols-outlined me-2">add</span>
            Add Progress Notes
          </button>
        </div>
      )}

      {notesData.length > 0 ? (
        <Card className="shadow-sm mb-3">
          <Card.Body>
            <Row className="g-3">
              {notesData.map((note, index) => renderThumbnail(note, index))}
            </Row>
          </Card.Body>
        </Card>
      ) : (
        <div>No Progress Notes Found!</div>
      )}

      {/* Pagination */}
      {totalPages > 1 && (
        <Pagination
          setPagination={setPagination}
          pagination={pagination}
          data={ProgressNoteData}
        />
      )}

      {/* Add Notes Modal */}
      <ModalComponent
        title="Add Progress Notes"
        show={progressNotesModal}
        body={
          <AddProgressNotes
            setProgressNotesModal={setProgressNotesModal}
            onSuccess={() => {
              setProgressNotesModal(false);
              refetch && refetch(); // refresh after add
            }}
          />
        }
        onClose={() => setProgressNotesModal(false)}
      />
    </div>
  );
};

export default ProgressNotes;
